import React from 'react';

import { I18n } from '@utils/index';

import { ICache } from '../InputAmountField';
import { InputBaseField } from '../InputBaseField';
import { FORM_KYYS } from '../useMain';
import { formatIntVal, validateRule } from '../utils';

interface InputCountFieldProps {
  className?: string;
  name: string;
  min: number;
  max: number;
  cacheRef: React.MutableRefObject<ICache>;
}

export const InputCountField: React.FC<InputCountFieldProps> = (props) => {
  const { name, className, min, max, cacheRef } = props;
  return (
    <InputBaseField
      className={className}
      name={name}
      label={I18n.t('fLcXyYfB')}
      min={min}
      max={max}
      inputMode="numeric"
      shouldUpdate={(prevValues, curValues) => {
        const arr = [FORM_KYYS.currency, name, FORM_KYYS.amount, FORM_KYYS.assignType];
        return arr.some(item => prevValues[item] !== curValues[item]);
      }}
      rules={[(form) => ({
        validator: (_, value) => {
          const realVal = formatIntVal(value);
          if (realVal < min) {
            return Promise.reject(new Error(I18n.t('tZJDgr2g', { min })));
          }
          if (realVal > max) {
            return Promise.reject(new Error(I18n.t('MwtMA4Fp', { max })));
          }
          const assignType = form.getFieldValue(FORM_KYYS.assignType); // 空投类型 幸运 or 普通
          const amount = form.getFieldValue(FORM_KYYS.amount); // 单个空投金额 or 总支付金额
          if (!amount) return Promise.resolve();
          const currency = form.getFieldValue(FORM_KYYS.currency); // 币种
          return validateRule(
            { amount: amount, cache: cacheRef, count: realVal, currency, assignType, form },
            { currKey: FORM_KYYS.num, linkageKey: FORM_KYYS.amount }
          );
        }
      })]}
      maxSign="≤"
    />
  );
}
